/* Careatic — small UI behaviours: FAQ accordion (single-open), sticky mobile
   CTA (reveal after scroll), rotating announcement bar. */
(function () {
  'use strict';

  /* ---- FAQ / SEO accordion: single-open, +→× rotate via [data-open] ---- */
  function accordions() {
    document.querySelectorAll('[data-ca-accordion]').forEach(function (root) {
      if (root.dataset.caBound) return;
      root.dataset.caBound = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ca-acc-item]'));
      items.forEach(function (item) {
        var q = item.querySelector('[data-ca-acc-q]');
        if (!q) return;
        q.addEventListener('click', function () {
          var open = item.getAttribute('data-open') === 'true';
          items.forEach(function (it) {
            it.setAttribute('data-open', 'false');
            var b = it.querySelector('[data-ca-acc-q]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          item.setAttribute('data-open', String(!open));
          q.setAttribute('aria-expanded', String(!open));
        });
      });
    });
  }

  /* ---- Sticky mobile CTA: reveal past threshold ---- */
  function sticky() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-ca-sticky]'));
    if (!bars.length) return;
    function onScroll() {
      bars.forEach(function (b) {
        var t = parseInt(b.dataset.threshold || '600', 10);
        b.setAttribute('data-show', String(window.scrollY > t));
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Rotating announcement messages ---- */
  function announce() {
    document.querySelectorAll('[data-ca-announce]').forEach(function (root) {
      if (root.dataset.caBound) return;
      root.dataset.caBound = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ca-announce-item]'));
      if (items.length < 2) return;
      var interval = parseInt(root.dataset.interval || '4200', 10);
      var i = 0;
      items.forEach(function (it, k) { it.style.display = k === 0 ? '' : 'none'; });
      setInterval(function () {
        items[i].style.display = 'none';
        i = (i + 1) % items.length;
        items[i].style.display = '';
      }, interval);
    });
  }

  /* ---- Responsive paired links: swap href on whole-box anchors by viewport
         (mirrors the prototype's useIsMobile link resolver) ---- */
  function respLinks() {
    var mq = window.matchMedia('(max-width: 767px)');
    function apply() {
      document.querySelectorAll('[data-ca-href-mobile]').forEach(function (a) {
        var d = a.getAttribute('data-ca-href-desktop') || a.getAttribute('href');
        var m = a.getAttribute('data-ca-href-mobile') || d;
        a.setAttribute('href', mq.matches ? m : d);
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function init() { accordions(); sticky(); announce(); respLinks(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
